module.exports = __webpack_public_path__ + "img/adjustment.586e85d2.svg";